module.exports = __webpack_public_path__ + "img/fu10.c1e710b5.png";